import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaPlus, FaMinus } from 'react-icons/fa';

const faqs = [
    {
        q: "Da li radi na Instagramu i sajtu?",
        a: "Da, naši agenti se mogu integrisati direktno u Instagram DM, Messenger i vaš sajt (Shopify/WooCommerce ili custom)."
    },
    {
        q: "Da li treba Shopify ili WooCommerce?",
        a: "Možemo se integrisati sa većinom platformi. Najveću vrednost donosimo shopovima koji već imaju uspostavljen workflow, bez obzira na platformu."
    },
    {
        q: "Koliko traje implementacija?",
        a: "Od audita do launcha obično prođe 7 do 14 dana, u zavisnosti od kompleksnosti vašeg kataloga i FAQ-a."
    },
    {
        q: "Da li chatbot može da pogreši?",
        a: "AI je napredan, ali nije nepogrešiv. Zato postavljamo jasne granice - ako chatbot nije 95% siguran u odgovor, upit prosleđuje ljudskom agentu."
    },
    {
        q: "Kako merite 80% automatizacije?",
        a: "Pratimo broj uspešno rešenih upita bez ljudske intervencije u odnosu na ukupan broj ponavljajućih pitanja koje smo definisali u bazi znanja."
    },
    {
        q: "Koliko košta?",
        a: "Cena zavisi od volumena poruka i nivoa personalizacije. Cilj nam je da ROI bude pozitivan već u prvom mesecu kroz uštedu vremena i povećanu prodaju."
    }
];

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(0);

    const trustBadges = [
        "Implementacija 7–14 dana",
        "Instagram + Web",
        "Merenje automatizacije"
    ];

    return (
        <section id="faq" className="py-20 bg-gradient-to-br from-black via-gray-900 to-black">
            <div className="max-w-4xl mx-auto px-4">
                <div className="flex flex-wrap justify-center gap-3 mb-12">
                    {trustBadges.map((badge, idx) => (
                        <div key={idx} className="px-4 py-2 rounded-full bg-white/5 border border-white/10 text-xs font-bold uppercase tracking-wider text-gray-400 hover:border-blue-500/40 transition-colors">
                            {badge}
                        </div>
                    ))}
                </div>

                <h2 className="text-3xl md:text-5xl font-bold mb-12 text-center">Česta pitanja</h2>

                <div className="space-y-4">
                    {faqs.map((faq, idx) => (
                        <div
                            key={idx}
                            className="border border-white/5 rounded-2xl overflow-hidden bg-gray-900/50 backdrop-blur-xl"
                        >
                            <button
                                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                                className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors"
                            >
                                <span className="text-lg font-semibold">{faq.q}</span>
                                {openIndex === idx ? (
                                    <FaMinus className="w-5 h-5 text-gray-400" />
                                ) : (
                                    <FaPlus className="w-5 h-5 text-gray-400" />
                                )}
                            </button>

                            <AnimatePresence>
                                {openIndex === idx && (
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <div className="px-6 pb-6 text-gray-400 leading-relaxed">
                                            {faq.a}
                                        </div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
